<template>
  <div>
    <channel-selector
      placeholder="请选择渠道"
      enableFullChannels
      @ready="onChannelSelectorReady"
      @change="onChannelSelectorChange"
      style="display: inline-block; margin-bottom: 15px"
      ref="channelSelector"
    >
    </channel-selector>
    <el-button
      style="margin-left: 10px"
      type="primary"
      @click="openEditMailTemplateDialog(true)"
      >添加模板</el-button
    >
    <el-table
      :data="mailTemplateTableData"
      border
      size="small"
      style="width: 700px"
    >
      <el-table-column
        prop="mailTemplateName"
        label="名称（不会在游戏里展示，可当作备注）"
        align="center"
        width="300"
      >
      </el-table-column>
      <el-table-column label="标题和正文" align="center" width="150">
        <template scope="scope">
          <el-popover placement="right" trigger="hover" width="600">
            <div>
              <el-tabs type="card" v-model="scope.row.activeLanguageTabName">
                <el-tab-pane
                  v-for="item in scope.row.languageTemplates"
                  :key="item.language"
                  :name="item.language"
                >
                  <span slot="label"
                    ><i
                      v-if="item.title == ''"
                      class="el-icon-info"
                      style="margin-right: 5px"
                    ></i
                    >{{ `[${item.language}]` }}</span
                  >
                  <div>
                    <label style="display: block">{{
                      `[${item.language}] 标题：`
                    }}</label>
                    <el-input
                      v-model="item.title"
                      readonly
                      placeholder="（这个会在游戏里展示）"
                    ></el-input>
                  </div>
                  <div style="margin-top: 5px">
                    <label style="display: block">{{
                      `[${item.language}] 正文：`
                    }}</label>
                    <el-input
                      type="textarea"
                      rows="15"
                      v-model="item.content"
                      readonly
                      placeholder="（这个也会在游戏里展示）"
                    ></el-input>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
            <el-button slot="reference" size="small" icon="el-icon-view"
              >查看</el-button
            >
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="" align="center" width="250">
        <template scope="scope">
          <el-button
            size="small"
            icon="el-icon-edit"
            @click="openEditMailTemplateDialog(false, scope.row)"
            >修改模板</el-button
          >          
          <el-button
            type="primary"
            size="small"
            icon="el-icon-s-promotion"
            @click="openSendMailDialog(scope.row)"
            >发送邮件</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- “添加邮件模板”对话框 -->
    <EditMailTemplateDialog
      v-if="shouldEditTemplateDialogVisible"
      @close="onEditMailTemplateDialogClosed()"
      :value="valueForEditMailTemplateDialog"
    ></EditMailTemplateDialog>

    <!-- “发送邮件”对话框 -->
    <SendMailDialog
      v-if="shouldSendMailDialogVisible"
      @close="onSendMailDialogClosed()"
      :value="dataForSendMailDialog"
    ></SendMailDialog>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("../../util");

import EditMailTemplateDialog from "./EditMailTemplateDialog";
import SendMailDialog from "./SendMailDialog";
import ChannelSelector from "@/components/ChannelSelector";

export default {
  data() {
    return {
      shouldEditTemplateDialogVisible: false, // “添加邮件模板”对话框是否应该显示出来
      shouldSendMailDialogVisible: false, // “发送邮件”对话框是否应该显示出来
      valueForEditMailTemplateDialog: null, // 要传递给“添加邮件模板”对话框的数据
      mailTemplateTableData: [], // 邮件模板列表里展示的数据
      dataForSendMailDialog: null, // 要传递给“发送邮件”对话框的数据
      languages: [], // 所有的语言
      channelId: 0,
    };
  },

  components: {
    EditMailTemplateDialog,
    SendMailDialog,
    ChannelSelector,
  },

  async created() {
    // 查询语言集合
    await this.getLanguageList();
  },

  methods: {
    async onChannelSelectorReady() {
      this.$refs.channelSelector.channelId = 0;
    },

    async onChannelSelectorChange(newChannelId, oldChannelId) {
      this.channelId = newChannelId;
      return this.loadMailTemplateList();
    },

    /**
     * 查询邮件模板集合
     */
    async loadMailTemplateList() {
      // 清空表格数据
      this.mailTemplateTableData = [];

      // 向服务器查询模板集合
      let resData = (
        await axios.get(
          `${util.getBackendApiBase()}/v1/getMailTemplateList/${
            this.channelId
          }`,
          {
            headers: {
              token: util.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message({
          message: resData.message,
          type: "error",
        });
        return;
      }

      let mailTemplateListInResponse = resData.data.mailTemplateList || [];

      for (let mailTemplateInResponse of mailTemplateListInResponse) {
        let languageTemplates = [];

        for (let language of this.languages) {
          let title = "";
          let content = "";

          for (let languageTemplateInResponse of mailTemplateInResponse.mailTemplate) {
            if (languageTemplateInResponse.language == language) {
              title = languageTemplateInResponse.title;
              content = languageTemplateInResponse.content;
              break;
            }
          }

          languageTemplates.push({
            language: language,
            title: title,
            content: content,
          });
        }

        this.mailTemplateTableData.push({
          mailTemplateId: mailTemplateInResponse.mailTemplateId,
          mailTemplateName: mailTemplateInResponse.mailTemplateName,
          languageTemplates: languageTemplates,
          activeLanguageTabName: this.languages[0],
        });
      }

      // 排序（按模板被创建的顺序倒序排列）
      this.mailTemplateTableData.sort((x, y) => {
        return Number(y.mailTemplateId) - Number(x.mailTemplateId);
      });
    },

    /**
     * 打开“添加邮件模板”对话框
     */
    async openEditMailTemplateDialog(isCreate, templateData) {
      this.shouldEditTemplateDialogVisible = true;
      this.valueForEditMailTemplateDialog = {
        isCreate: isCreate,
        channelId: this.channelId,
        templateData: templateData,
      };
    },

    /**
     * “添加邮件模板”对话框关闭了
     */
    async onEditMailTemplateDialogClosed() {
      this.shouldEditTemplateDialogVisible = false;

      // 重新拉取邮件模板集合
      return this.loadMailTemplateList();
    },

    /**
     * 打开“发送邮件”对话框
     */
    async openSendMailDialog(templateData) {
      this.shouldSendMailDialogVisible = true;
      this.dataForSendMailDialog = {
        channelId: this.channelId,
        mailTemplate: templateData,
      };
    },

    /**
     * “发送邮件”对话框关闭了
     */
    async onSendMailDialogClosed() {
      this.shouldSendMailDialogVisible = false;
    },

    /**
     * 查询语言集合
     */
    async getLanguageList() {
      var resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/getLanguageList`,
          {},
          {
            headers: {
              token: util.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        if (resData.code != 10015) {
          this.$message.error(resData.message);
          return;
        }

        return;
      }

      if (resData.data.languageList) {
        for (let l of resData.data.languageList) {
          this.languages.push(l);
        }
      }
    },
  },
};
</script>